import React from 'react';

const GrayLine = props => {
    return(
        <div className={`w-100 mb-2 `} style={{ height: 1.5, backgroundColor: '#d0d0d0' }}></div>

    )

}
export default GrayLine;